<script setup lang="ts">
const props = defineProps<{
  name: string
}>()
const modelValue = defineModel<boolean>({ required: true })
defineOptions({ inheritAttrs: false })
</script>

<template>
  <div class="mb-4 flex items-center">
    <input
      :id="props.name"
      :name="props.name"
      v-bind="$attrs"
      type="checkbox"
      v-model="modelValue"
      class="peer h-4 w-4 rounded-sm border-gray-300 bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500"
    />
    <label
      :for="props.name"
      class="ms-2 text-sm font-medium text-gray-900 peer-disabled:text-gray-400"
      >{{ props.name }}</label
    >
  </div>
</template>
